export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10245.3a4261f4.jpg";